export default {
	NOTIFICATIONS: 'companies/:company_id/notifications/',
}
